import { useQuery } from '@tanstack/react-query';
import { fetchDocuments } from 'utils/documentUtils';
export function useOrderRateCards(orderId, options = {}) {
    const { shipperId, carrierId } = options;
    return useQuery(['order-rate-cards', orderId, shipperId, carrierId], async () => {
        if (!orderId) {
            return {
                shipperAccountId: shipperId !== null && shipperId !== void 0 ? shipperId : null,
                carrierAccountId: carrierId !== null && carrierId !== void 0 ? carrierId : null,
                shipperRateCard: null,
                carrierRateCard: null,
            };
        }
        // At order level we rely on provided carrierId (no inference)
        const inferredCarrierId = carrierId !== null && carrierId !== void 0 ? carrierId : null;
        // Fetch latest rate cards where applicable
        const [shipperRateCard, carrierRateCard] = await Promise.all([
            shipperId ? fetchDocuments(shipperId, 'customer_rate_card') : null,
            inferredCarrierId
                ? fetchDocuments(inferredCarrierId, 'carrier_rate_card')
                : null,
        ]);
        return {
            shipperAccountId: shipperId !== null && shipperId !== void 0 ? shipperId : null,
            carrierAccountId: inferredCarrierId,
            shipperRateCard,
            carrierRateCard,
        };
    }, {
        enabled: Boolean(orderId),
        staleTime: 30000,
    });
}
